import { DashboardContainer } from './Dashboard.styles';
import ISSTracker from '../components/ISSTracker';

function Dashboard() {
  return (
    <DashboardContainer>
      <ISSTracker />
    </DashboardContainer>
  );
}

export default Dashboard;
